// extracted by mini-css-extract-plugin
module.exports = {"inputCustom":"style_inputCustom__KWyF9","inputNoBorder":"style_inputNoBorder__NLKW_"};